import { Divider, Header } from "semantic-ui-react";

const AttorneyText = () => {
  return (
    <div>
      <Header
        content="1. Profile"
        subheader="Complete your profile to help us match you with Court Reporters when creating jobs."
      />
      <Header
        content="2. Request New Job"
        subheader="Click on Request New Job to begin setting up a new job through Stenexus and searching for a Court Reporter to participate."
      />
      <Header>
        <Header.Subheader>
          Once the Court Reporter confirms your job request, you will be
          notified via email. You can also view the current status of your jobs
          inside Stenexus at any time.
        </Header.Subheader>
      </Header>
    </div>
  );
};
export default AttorneyText;
